import React, { useState } from 'react';
import { authService } from '../api/axios';
import {
  Button,
  TextField,
  Box,
  Typography,
  Alert,
  CircularProgress,
  Link as MuiLink
} from '@mui/material';
import { Link } from 'react-router-dom';

function ForgotPassword() {
  const [emailOrUsername, setEmailOrUsername] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!emailOrUsername.trim()) {
      setError('Please enter your email or username.');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await authService.post('/auth/forgot-password', { emailOrUsername });
      setMessage(response.data); // Backend sends a generic success message
    } catch (err) {
      console.error('Forgot password request failed:', err.response || err);
      // Display generic message even on error to prevent user enumeration
      setMessage('If an account with that email or username exists, a password reset link has been sent.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box className="form-card">
      <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'center' }}>
        Forgot Password?
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: 'center' }}>
        Enter your registered email address or username and we'll send you a link to reset your password.
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Email or Username"
          value={emailOrUsername}
          onChange={(e) => setEmailOrUsername(e.target.value)}
          required
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2 }}
          disabled={isSubmitting}
        >
          {isSubmitting ? <CircularProgress size={24} /> : 'Send Reset Link'}
        </Button>
      </form>
      {message && <Alert severity="info" sx={{ mt: 2 }}>{message}</Alert>}
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
        Remember your password?{' '}
        <MuiLink component={Link} to="/login" sx={{ textTransform: 'none' }}>
          Login here
        </MuiLink>
      </Typography>
    </Box>
  );
}

export default ForgotPassword;
